import React, { useCallback, useEffect, useState } from 'react'
import { Outlet } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import Footer from "../../components/Footer";
import { useDispatch, useSelector } from 'react-redux';
import { fetchClientData, resetClientState } from "../../feaures/store/redux/clientSlice"

const RootLayout = () => {
    const dispatch = useDispatch()
    const clientStore = useSelector((state) => state.client)
    const [clientData, setClientData] = useState([])

    const getClientList = useCallback(() => {
        const data = {
            path: "webUsers"
        }
        dispatch(fetchClientData(data))
    }, [])

    useEffect(() => {
        getClientList()
    }, [])

    useEffect(() => {
        if (clientStore.fetchClient.success) {
            setClientData(clientStore.fetchClient.data[0])
            dispatch(resetClientState("fetch"))
        }
    }, [
        clientStore.fetchClient.success
    ])
    return (
        <div className="app-container">
            <Navbar data={{ header_email: clientData.header_email, header_phone: clientData.header_phone, header_phone2: clientData.header_phone2, favicon: clientData.app_favicon, logo: clientData.app_logo }} />
            <div className="layout">
                <Sidebar logo={clientData.app_logo} />
                <div className="content" style={{ marginTop:"65px", paddingTop: "50px" }}>
                    <Outlet data={clientData} />
                    <Footer data={{
                        footer_description: clientData.footer_description,
                        header_email: clientData.header_email,
                        header_phone: clientData.header_phone,
                        header_phone2: clientData.header_phone2,
                        social_instagram: clientData.social_instagram,
                        social_linkedin: clientData.social_linkedin,
                        social_twitter: clientData.social_twitter,
                        social_fb: clientData.social_fb,
                        app_logo: clientData.app_logo
                    }} />
                </div>
            </div>
        </div>
    )
}

export default RootLayout